import i18next from 'i18next';
// eslint-disable-next-line no-restricted-imports
import { CUSTOM_TAGS_OPTIONS } from '_legacy/components/Shared/CustomTags';
// eslint-disable-next-line no-restricted-imports
import FILTER_TYPES from '@shared/ui/Table/Filters/constants';

export const ACCOUNT_COLUMNS = [
  {
    size: 200,
    header: i18next.t('tables:customTags'),
    accessorKey: 'customTags',
    filter: {
      filterType: FILTER_TYPES.SELECT,
      options: CUSTOM_TAGS_OPTIONS,
    },
    cell: {
      withBubbles: true,
    },
  },
  {
    size: 300,
    header: i18next.t('tables:name'),
    accessorKey: 'businessName',
    filter: {
      filterType: FILTER_TYPES.SELECT_WITH_DYNAMIC_HINT,
    },
    isDefaultCell: true,
  },
  {
    size: 180,
    header: i18next.t('tables:customId'),
    accessorKey: 'customIdentifier',
    enableHiding: false,
    filter: {},
    isDefaultCell: true,
  },
  {
    size: 300,
    header: i18next.t('tables:address'),
    accessorKey: 'address',
    filter: {},
    isDefaultCell: true,
  },
];
